
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiEnergyMethanol as ObiEnergyMethanolElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-energy-methanol.js';
 
 
 

 
 export const ObiEnergyMethanol = createComponent({
   react: React,
   tagName: 'obi-energy-methanol',
   elementClass: ObiEnergyMethanolElement,
   events: {
     
   }
  });
 
 